
$(document).ready(function(){
                $('#mag img')
                  .wrap('')
                  .css('display', 'block')
                  .parent()
                  .zoom();
                 });


